import { readSession } from '../_services/webSession';

export function authHeader(user = readSession()) {
    if (user?.token && Date.parse(user.expiresAt) > Date.now()) {
        return { Authorization: `Bearer ${user.token}` };
    }

    if (user && !user.token && user.authdata) {
        return { 'Authorization': 'Basic ' + user.authdata };
    } else {
        return {};
    }
}